<template>
    <app-wrapper>
        <app-header medium-max-width="max-w-1000" :long="true" :is-hidden-menu="true">
            <template #top>
            </template>
        </app-header>
        <app-body medium-max-width="max-w-1000">

            <template #main>
                
                <AppBoxContent 
                    class="my-2 mt-[-115px]"
                    width="full" 
                    rounded="lg"
                    bg-class-color="bg-white" 
                    :use-min-height="false"
                    :remove-max-width="true"
                >
                    <div class="text-center pt-20 pb-6">
                        <div class="check-mark">
                            <i class="fa fa-exclamation-triangle text-yellow-600 text-[70px]"></i>
                        </div>
                        <div class="pt-6 pb-20">
                            <h2>Refinancing is Temporarily Unavailable</h2>
                            <p class="text-[#7B7B7B] mt-4 max-w-2xl mx-auto">{{ storeData.message }}</p>
                        </div>
                        <div class="pt-6">
                            <div class="pb-2"><LinkButton :href="storeData.portalUrl" type="orange">View My Account</LinkButton></div>
                        </div>
                    </div>
                </AppBoxContent>

            </template>
        </app-body>
    </app-wrapper>
</template>

<script>
import AppBoxContent from '../../../../components/AppBoxContent.vue';
import LinkButton from '../components/LinkButton.vue';
import { RefinanceStepMixin } from './../mixins/RefinanceStepMixin';
import { RefinanceFiltersMixin } from './../mixins/RefinanceFiltersMixin';

export default {
    name: 'RefinanceUnavailable',
    mixins: [RefinanceStepMixin, RefinanceFiltersMixin],
    components: {
        AppBoxContent,
        LinkButton,
    },

    data() {
        return {
        }
    },
}
</script>
